const Aggression = require("../../entities/Aggression");
const { Age }  = require("../Constants");
const AggessionNames = require("../Names/AggressionNames");

class ArmedIntervention extends Aggression {
    constructor() {
        super(
            Age.Age3,
            AggessionNames.ArmedIntervention,
            2,
            "Take up to 7 culture from your rival.",
            {
                //effect
            }
        )
    }
}

module.exports = ArmedIntervention;